
import Gutter from '@/ui-kit/components/gutter';
import ModalService from '@/ui-kit/components/modal/ModalService';
import {
  StyleSizeType,
  StylePositionType,
  StyleColorSchemeType,
} from '@/ui-kit/styles/enums';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import { ToastMessage } from '@/ui-kit/components/toast/enums';
import { FormEventType } from '@/ui-kit/components/form/enums';
import ExternalLink from '@/ui-kit/components/external-link';
import { ExternalLinks } from '@/utils/external-navigation/constants';
import { ExternalLinkProperty } from '@/ui-kit/components/external-link/enums';
import { SoldDataEvent } from '@/constants/AnalyticEvents';
import SoldDataStoreName from '@/store/sold-data/name';
import SoldDataApiService from '@/services/api/sold-data';
import NewListingApiService from '@/services/api/serverless/new-listing';
import ListingsMaps from '@/components/maps/entities/searchListings';
import { MapProperty } from '@/components/maps/enums';
import ToastService from '@/components/toast/toast-service';
import ContentInfoCard from '@/components/ContentInfoCard';
import { SoldDataTableEventType } from './table/enums';
import TableMapper from './mappers/TableMapper';
import SoldDataTable from './table';
import SoldDataContactUs from './contact-us';
import ListingsMapper from './mappers/ListingsMapper';
import SoldDataShare from './share';
import SoldDataShareModal from './share/modal';
import { SoldDataShareEvenType } from './share/enums';
import SoldDataSearchForm from '../../features/sold-data/components/sold-data/search-form';
import SoldDataFiltersForm from '../../features/sold-data/components/sold-data/filters-form';
import SoldDataHeader from '../../features/sold-data/components/sold-data/header';
import { FormProperty } from '../../features/sold-data/shared/components/enums';
import HandleForms from './mixins/HandleForms';
import HandleMap from './mixins/HandleMap';
import CheckFilterValues from './mixins/CheckFilterValues';

export default {
  name: 'SoldData',
  components: {
    ListingsMaps,
    Gutter,
    SoldDataShare,
    SoldDataContactUs,
    ContentInfoCard,
    SoldDataTable,
    SoldDataFiltersForm,
    SoldDataSearchForm,
    SoldDataHeader,
    ExternalLink,
  },
  mixins: [CheckFilterValues, HandleForms, HandleMap],
  data() {
    return {
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      SoldDataShareEvenType,
      SoldDataTableEventType,
      FormEventType,
      FormProperty,
      MapProperty,
      GutterProperty,
      ExternalLinkProperty,
      ExternalLinks,
      tableRows: [],
    };
  },
  computed: {
    soldDataFooterContent() {
      return this.$store.state[SoldDataStoreName].footerContent;
    },
  },
  watch: {
    listings(listings) {
      this.tableRows = TableMapper.getTableRowsFromListings(listings);
    },
  },
  async mounted() {
    this.initSearchForm();
    this.initFilterForm();

    if (this.checkSearchValues(this.$route.query)) {
      await this.loadResultsBySearch(this.searchForm.value);
    } else if (this.checkFiltersValues(this.$route.query)) {
      await this.loadResultsByFilters(this.filtersForm.value);
    }
  },
  methods: {
    async handleShareButtonClick() {
      this.trackShareButtonClick();

      const shareModalResult = await ModalService.open({ component: SoldDataShareModal });

      if (shareModalResult) {
        await SoldDataApiService.sendShareEmail({
          url: this.$route.fullPath,
          email: shareModalResult.email,
          name: shareModalResult.name,
        });

        ToastService.openPositive(ToastMessage.SoldDataShareSuccessful);
      }
    },
    handleTrackComparableButtonClick() {
      this.$track(SoldDataEvent.ComparableClick);
    },
    trackShareButtonClick() {
      this.$track(SoldDataEvent.ShareClick);
    },
    handleListingsLoad() {
      this.setMapBounds(ListingsMapper.mapToBoundaries(this.listings));
    },
    handleTransactionChange({ row, index }) {
      this.tableRows.splice(index, 1, row);
    },
    async handleToggleListingVisibility(listingId) {
      await NewListingApiService.deleteSoldListing(listingId);

      this.filterOutListingById(listingId);
    },
    filterOutListingById(listingId) {
      this.listings = this.listings.filter((listing) => (listing.listingId !== listingId));
    },
  },
};
